import { render, staticRenderFns } from "./ThgInsuranceCheck.vue?vue&type=template&id=779d9cf8"
import script from "./ThgInsuranceCheck.vue?vue&type=script&lang=ts"
export * from "./ThgInsuranceCheck.vue?vue&type=script&lang=ts"
import style0 from "./ThgInsuranceCheck.vue?vue&type=style&index=0&id=779d9cf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports